import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { AccountService } from '../../../core/service/app/account.service';
import { RouterService } from '../../../core/service/core/router.sevice';


@Component({
  selector: 'app-register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.scss']
})
export class RegisterFormComponent extends FormBaseComponent<any> implements OnInit {

  @Output()
  onSuccess = new EventEmitter<any>();

  @Input()
  goToLogin = true;

  estado = 'registrar'

  codigo = '';
  error = '';
  badcode = false;


  constructor
  (
    private accountService: AccountService, 
    private routerService: RouterService,
    
  ) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  template() {
    this.form.addControl('email', new FormControl('', [Validators.required, Validators.email]));
    this.form.addControl('password', new FormControl('', Validators.required));
    this.form.addControl('passwordRepeat', new FormControl('', Validators.required))
  }

  send() {
    if (this.form.valid) {
      this.error = '';
      var x = this.data();
      this.accountService.register(this.data())
        .then(result => {
          if (result === 'email_already_exist') {
            this.error = 'El Usuario ya existe';
            return;
          }
          if (result === 'passwords_not_match') {
            this.error = 'Las contraseñas no son las mismas';
            return;
          }

          if(result === 'ok')
          {
            this.onSuccess.emit(this.form.value);
            this.estado = 'confirmar';
            setTimeout(() => {
              this.accountService.finish();
            }, 10000);
          }
        })
    }
  }

  verificacion() {
    this.badcode = false;
    if (this.codigo.length > 0) {
      this.accountService.verificar(this.form.get('email').value, this.codigo)
        .then(result => {
          result = true;
          if (result) {
            this.estado = 'success'
            this.onSuccess.emit(this.form.value);
            this.clear();
            if (this.goToLogin) {
              setTimeout(() => {
                this.routerService.go('/account')
              }, 2000);
            }
          } else {
            this.badcode = true;
          }
        })

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/register-form/register-form.component.ts